import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { ManualCheckService } from "../../../../services/ManualCheckService";
import { CommonService } from "../../../../services/CommonService";
import { LeadService } from "../../../../services/LeadService";

export const useRiskCLevel = (changeAlert: ChangeAlertCallbackType, data, lead, handleSectionChange) => {
    const manualCheckService = useRef<ManualCheckService>();
    const commonService = useRef<CommonService>();
    const leadService = useRef<LeadService>();
    
    const [loading, setLoading] = useState(false);
    const [check, setCheck] = useState(null);
    const catalogStatus = [
        { key: "approved", value: "Aprobado" },
        { key: "rejected", value: "Rechazado" },
    ];
    const checkList = [
        { label: "Razón de Solicitud:", value: ["reason_request"] },
        { label: "Revisó:", value: ["agent_response", "name"] },
        { label: "Fecha de revisión:", value: ["udate"], type: "date" },
        { label: "Dictamen:", value: ["result", "status"], catalog: catalogStatus },
        { label: "Motivo:", value: ["result", "reason"] },
        { label: "Comentarios:", value: ["result", "comment"] },
        { label: "Evidencia:", value: ["result", "files"], type: "link" },
    ];

    const afbClevelFind = async () => {
        setLoading(true);

        let data = {
            lead: { uuid: lead.uuid },
        };

        const resp = await manualCheckService.current.afbClevelFind(data);
        setLoading(false);

        if (resp?.data?.response === "OK") {
            setCheck(resp.data.content);
        }
    };

    const onRequestAuth = async (item) => {
        setLoading(true);
        const agent = localStorage.session ? JSON.parse(localStorage.session) : {};
        const comercialName = await getLeadSection(item.uuid, "COMPANY_INFO");

        let payload = {
            lead: {
                uuid: item.uuid,
                email: item.email,
                responsible: item.responsible,
                social_reason: comercialName ? `${comercialName}, ${item.social_reason}` : item.social_reason,
                status: item.status,
                type: item.type,
                risk_level: data["risk_level"]
            },
            agent_request: {
                uuid: agent["uuid"],
                email: agent["email"],
                name: agent["name"],
            },
            status: "assigned",
        };
        if(item["reason_request"]){
            payload["reason_request"] = item["reason_request"];
        }

        const resp = await manualCheckService.current.afbClevelCreate(payload);

        if (resp?.data?.response === "OK") {
            changeAlert(true, "OK", "Autorización solicitada con éxito.");
            const sectionInfo = {
                lead_uuid: item.uuid,
                section_name: "RISK_LEVEL",
            };
            setLoading(false);
            await handleSectionChange(sectionInfo);
        } else {
            setLoading(false);
            changeAlert(true, "error", resp["message"] || resp["data"].message || "Error al consultar servicio");
        }
    };

    const getLeadSection = async (leadUuid: string, sectionName: string) => {
        const response = await leadService.current.getOnboardingSectionLead({
            lead_uuid: leadUuid,
            section_name: sectionName
        })

        const responseData = response.data?.content?.details?.["comercial_name"] || null;
        return responseData;
    };

    const getPath = (data) => {
        let pos = data.indexOf("evidence");
        let sub = "";
        if (pos > -1) {
          sub = data.substring(pos, data.length);
        }
        return sub;
    };

    const downloadFile = async (data) => {
        setLoading(true);
        let path = getPath(data);

        if (path) {
            const request = await commonService.current.downloadFile(path);
            if (request.data.response === "OK") {
                window.open(request.data.content, "_blank");
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        setCheck(null);
        manualCheckService.current = new ManualCheckService(changeAlert);
        commonService.current = new CommonService(changeAlert);
        leadService.current = new LeadService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return { loading, lead, check, checkList, afbClevelFind, onRequestAuth, downloadFile };
};
